import React, { Fragment } from "react";
import _ from "lodash";
import "./ListItem.less";
// ------------------------------------------------------------------------------------------------
export interface ListItemProps {
    key?: string | number;
    primaryText?: string;
    primaryTextStyle?: React.CSSProperties;
    secondaryText?: string;
    secondaryTextStyle?: React.CSSProperties;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
    nestedItems?: React.ReactNode[];
    style?: React.CSSProperties;
    nestedItemsStyle?: React.CSSProperties;
    initiallyOpen?: boolean;
    noHover?: boolean;
    onNestedListToggle?: () => void;
    onClick?: () => void;
}
// ------------------------------------------------------------------------------------------------
export interface ListItemState {
    listOpen: boolean;
}
// ------------------------------------------------------------------------------------------------
export default class ListItem extends React.Component<ListItemProps, ListItemState>{
    constructor(props: ListItemProps) {
        super(props);

        this.state = {
            listOpen: props.initiallyOpen ?? false
        };
    }
    // --------------------------------------------------------------------------------------------
    toggleList = () => {
        this.setState({ listOpen: !this.state.listOpen });

        if (this.props.onNestedListToggle != null)
            this.props.onNestedListToggle();
        if (this.props.onClick != null)
            this.props.onClick();
    }
    // --------------------------------------------------------------------------------------------
    render() {
        let validNestedItems = this.props.nestedItems != null && !_.isEmpty(this.props.nestedItems);

        return <Fragment>
            <div
                key={this.props.key}
                className={`yodiwo-list-item ${this.props.noHover ? 'no-hover' : ''}`}
                onClick={validNestedItems ? this.toggleList : this.props.onClick}
                style={this.props.style}
            >
                {this.props.leftIcon != null
                    ? <div key="left-icon" id="icon">{this.props.leftIcon}</div>
                    : null}

                <div id="yodiwo-list-item-body">
                    <div id="primaryText" style={this.props.primaryTextStyle}>
                        {this.props.primaryText}
                    </div>
                    {this.props.secondaryText != null
                        ? <div id="secondaryText" style={this.props.secondaryTextStyle}>
                            {this.props.secondaryText}
                        </div>
                        : null}
                </div>

                {this.props.rightIcon != null
                    ? <div key="right-icon" id="icon">{this.props.rightIcon}</div>
                    : null}

                {validNestedItems ? (this.state.listOpen ?
                    <i className="fas fa-angle-up center" id="arrow" key="arrow" /> :
                    <i className="fas fa-angle-down center" id="arrow" key="arrow" />
                ) : null}
            </div>
            {validNestedItems && this.state.listOpen
                ? <div
                    key={this.props.key + "-nested"}
                    className="yodiwo-list-item-nested-items"
                    style={this.props.nestedItemsStyle}>{this.props.nestedItems}</div>
                : null}
        </Fragment>
    }
    // --------------------------------------------------------------------------------------------
}
// ------------------------------------------------------------------------------------------------